module.exports = __webpack_public_path__ + "img/EntryDonutAging.f9f1d73e.png";